<template>
  <div id="img-to-show" @click="galeryOff()">
    <img :src="imgToShow" @click="galeryOff()" />
    <svg id="exit" @click="galeryOff()" width="calc(1080px * 0.05)" height="calc(1080px * 0.05)" viewBox="0 0 24 24">
      <path
        d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'img-to-show',
  data() {
    return {};
  },
  methods: {
    galeryOff() {
      this.$store.commit('STATE_SET_GALERY_OPEN', false);
    },
  },
  computed: {
    imgToShow() {
      return this.$store.getters.getImgToShow;
    },
  },
};
</script>
<style lang="sass">
@import '../../style/base'
@import '../../style/animation'

#img-to-show
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0,0,0,.95)
  z-index: 2000
  text-align: center
  display: flex
  align-items: center
  justify-content: center
  #exit
    cursor: pointer
    top: calc(1080px * 0.01)
    right: calc(1080px * 0.01)
    width: calc(1080px * 0.05)
    height: calc(1080px * 0.05)
    position: fixed
    path
      fill: $MAC_SECONDARY_COLOR
  img
    max-width: 80%
    width: 80%
    max-height: 80%
    object-fit: contain
</style>
